import React, { Component } from 'react';

import { connect } from 'react-redux';
import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, pathToJS, dataToJS } = helpers;

import { keyedObjToArr } from '../util';

class VisibleOnlyAdminComponent extends Component {
	render () {
		if(this.props.profile && this.props.profile.role === 'admin') {
			return this.props.children;
		} else {
			return (<span />);
		}
	}
}

const fbWrappedVisibleOnlyAdminComponent = firebaseConnect()(VisibleOnlyAdminComponent);

export const VisibleOnlyAdmin = connect(
	({ firebase }) => ({
		profile: pathToJS(firebase, 'profile'),
		auth: pathToJS(firebase, 'auth')
	})
)(fbWrappedVisibleOnlyAdminComponent);

class VisibleOnlyCustomerComponent extends Component {
	render () {
		if(this.props.profile && this.props.profile.customer) {
			return this.props.children;
		} else {
			return (<span />);
		}
	}
}

const fbWrappedVisibleOnlyCustomerComponent = firebaseConnect()(VisibleOnlyCustomerComponent);

export const VisibleOnlyCustomer = connect(
	({ firebase }) => ({
		profile: pathToJS(firebase, 'profile'),
		auth: pathToJS(firebase, 'auth')
	})
)(fbWrappedVisibleOnlyCustomerComponent);


class VisibleOnlyActiveOrderComponent extends Component {
    render () {
        if (!isLoaded(this.props.orders)) {
            return (<span />);
        }

        let activeOrder = false;
        if (this.props.orders) {
            keyedObjToArr(this.props.orders).forEach((orderItem) => {
                if (orderItem.status === 'active') {
                    activeOrder |= true;
                }
            }, this);
        }

        if(activeOrder || (this.props.profile && this.props.profile.role === 'admin')) {
            return this.props.children;
        } else {
            return (<span />);
        }
    }
}

const fbWrappedVisibleOnlyActiveOrderComponent = firebaseConnect( ({auth, profile}) => {

    if(!profile){
        return [];
    } else if (profile.customer) {
        return [
            {
                path: 'users',
                storeAs: 'users',
                queryParams: [ `orderByChild=customer`, `equalTo=${profile.customer}`]
            },
            {
                path: 'customers/'+profile.customer,
                storeAs: 'customer'
            },
            {
                path: 'orders',
                storeAs: 'orders',
                queryParams: [ `orderByChild=customer`, `equalTo=${profile.customer}`]
            }
        ];;
    } else if (profile.role === 'admin'){
        return [
            {
                path: 'users',
                storeAs: 'users'
            },
            {
                path: 'customers',
                storeAs: 'customer'
            },
            {
                path: 'orders',
                storeAs: 'orders'
            }
        ];;
    }

})(VisibleOnlyActiveOrderComponent);

export const VisibleOnlyActiveOrder = connect(
    ({ firebase }) => ({
        profile: pathToJS(firebase, 'profile'),
        auth: pathToJS(firebase, 'auth'),
        customer: dataToJS(firebase, 'customer'),
        users: dataToJS(firebase, 'users'),
        orders: dataToJS(firebase, 'orders')
    })
)(fbWrappedVisibleOnlyActiveOrderComponent);





// WEBPACK FOOTER //
// ./js/components/AuthenticatedComponent.js